import { render, staticRenderFns } from "./OriginLink.vue?vue&type=template&id=e6463a16&"
import script from "./OriginLink.vue?vue&type=script&lang=ts&"
export * from "./OriginLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports